import {
  Neutral200,
  Neutral300,
  Neutral500,
  Neutral600,
  Warning500,
  Brand50,
  Brand100
} from '@src/utils/colors';

export { Neutral300, Neutral600, Warning500, Brand100 };

export const TotalHolisticRevenueColor = '#00A3B6';
export const GeoMMMColor = '#C9F7FD';
export const RMMMColor = '#A4F1FD';
export const BrandEquityColor = '#8ADBEB';
export const IconGreyColor = '#99A1AF';
export const RevenueColor = TotalHolisticRevenueColor;
export const ROASColor = Warning500;
export const AxisColor = Neutral600;
export const PinnedSpendLineColor = Brand50;
export const BaselineRowColor = Neutral200;
export const GridColor = Neutral300;
export const InactiveTextColor = Neutral500;
